export const RATIO = {
  SQUARE: 'Square',
  RECTANGLE_3x4: 'Rectangle_3x4',
} as const
